import { ExchangeRateList } from "@/modules/exchangeRate/components";

export const ExchangeRateWidget = () => {
  return (
    <div className="dashboard-exchange-widget">
      <ExchangeRateList rowCount={4} isInWidget hasSeeMore hasTitle/>
    </div>
  );
};
